import { format } from 'date-fns';

export function formatDate(date: Date | string, formatString?: string) {
    if (typeof date === 'string')
        date = new Date(date);

    return format(date, formatString ? formatString : "h:mm a 'on' MM/dd/yyyy");
}